import { IDecayCalibration } from '@models/decay/decay-calibration';
import { IDecayEstimate } from '@models/decay/decay-estimate';

export const parseDecayEstimateSetting = (calibration: IDecayCalibration): IDecayCalibration => {
  if (calibration.hasOwnProperty('DecayEstimateSetting')) {
    try {
      const settings = calibration.DecayEstimateSetting as unknown;
      if (typeof settings === 'string') {
        calibration.DecayEstimateSetting = JSON.parse(settings) as IDecayEstimate[];
      }
    } catch (err) {
      calibration.DecayEstimateSetting = [];
      console.warn('Error building changelog.Calibration.DecayEstimateSetting');
    }
  } else {
    calibration.DecayEstimateSetting = [];
  }

  return calibration;
};
